// src/pages/CustomFoodForm.js — 내 음식 등록/수정 창. 대표 영양(펼침) / 상세 영양(접힘), 모두 100g 기준
import React, { useEffect, useState } from 'react';
import Modal from '../components/ui/Modal';

const MAIN_FIELDS = [
  ['kcal', '칼로리', 'kcal'], ['carbo', '탄수화물', 'g'], ['protein', '단백질', 'g'], ['fat', '지방', 'g'],
  ['sugar', '당', 'g'], ['dietFiber', '식이섬유', 'g'], ['water', '수분', 'g'],
];
const DETAIL_FIELDS = [
  ['na', '나트륨', 'mg'], ['choles', '콜레스테롤', 'mg'], ['satFat', '포화지방', 'g'], ['unsatFat', '불포화지방', 'g'],
  ['transFat', '트랜스지방', 'g'], ['allulose', '알룰로스', 'g'], ['erythritol', '에리스리톨', 'g'], ['glucose', '포도당', 'g'],
  ['caffeine', '카페인', 'mg'],
];
const ALL = [...MAIN_FIELDS, ...DETAIL_FIELDS].map(([k]) => k);

const toForm = (food) => {
  const f = { foodNm: food?.foodNm || '' };
  ALL.forEach((k) => {
    const v = food?.[k];
    f[k] = v === null || v === undefined || Number(v) === 0 ? '' : String(Number(v));
  });
  return f;
};

export default function CustomFoodForm({ open, food, saving, onClose, onSubmit }) {
  const edit = !!food?.foodCd;
  const [form, setForm] = useState(toForm(food));
  const [showDetail, setShowDetail] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setForm(toForm(food));
    setError('');
    // 상세 영양에 값이 있으면 펼쳐서 보여준다
    setShowDetail(DETAIL_FIELDS.some(([k]) => Number(food?.[k]) > 0));
  }, [open, food]);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = () => {
    if (!form.foodNm.trim()) { setError('음식 이름을 입력해 주세요.'); return; }
    const bad = ALL.find((k) => form[k] !== '' && !(Number(form[k]) >= 0));
    if (bad) { setError('영양 성분은 0 이상의 숫자로 입력해 주세요.'); return; }
    const payload = { foodNm: form.foodNm.trim() };
    ALL.forEach((k) => { payload[k] = form[k] === '' ? 0 : Number(form[k]); });
    if (edit) payload.foodCd = food.foodCd;
    onSubmit(payload);
  };

  const field = ([k, label, unit]) => (
    <label key={k} className="cf-field">
      <span>{label}</span>
      <input className="input" type="number" min="0" step="any" value={form[k]} onChange={(e) => set(k, e.target.value)} placeholder="0" />
      <em>{unit}</em>
    </label>
  );

  return (
    <Modal
      open={open}
      title={edit ? '내 음식 수정' : '새 음식 등록'}
      size="md"
      onClose={onClose}
      footer={(
        <>
          <button className="btn ghost" type="button" onClick={onClose}>취소</button>
          <button className="btn primary" type="button" disabled={saving} onClick={submit}>{saving ? '저장 중…' : '저장'}</button>
        </>
      )}
    >
      <label className="cf-name">
        <span>음식 이름</span>
        <input className="input" value={form.foodNm} onChange={(e) => set('foodNm', e.target.value)} placeholder="예: 엄마표 김치볶음밥" autoFocus />
      </label>

      <h3 className="cf-sub">대표 영양 <small>100g 기준 · 비우면 0</small></h3>
      <div className="cf-grid">{MAIN_FIELDS.map(field)}</div>

      <button className="btn ghost cf-toggle" type="button" onClick={() => setShowDetail((v) => !v)}>
        {showDetail ? '상세 영양 접기 ▲' : '상세 영양 입력 ▼'}
      </button>
      {showDetail && <div className="cf-grid">{DETAIL_FIELDS.map(field)}</div>}

      {error && <p className="cf-error">{error}</p>}
    </Modal>
  );
}
